import { registerLocale } from 'i18n-iso-countries';
import localeDE from 'i18n-iso-countries/langs/de.json';
import localeEN from 'i18n-iso-countries/langs/en.json';
import localeFR from 'i18n-iso-countries/langs/fr.json';
import localeKO from 'i18n-iso-countries/langs/ko.json';
import React from 'react';
import { Provider } from 'react-redux';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { createFirestoreInstance } from 'redux-firestore';
import { PersistGate } from 'redux-persist/integration/react';
import { RoutesProvider } from './context/RoutesContext';
import { FeatureController } from './controllers/FeatureController';
import { app } from './firebase';
import { routes } from './routes';
import store, { persistor } from './shared/store';

const reactReduxFirebaseProps = {
  firebase: app,
  config: {
    userProfile: 'users',
    useFirestoreForProfile: true,
  },
  dispatch: store.dispatch,
  createFirestoreInstance,
};

registerLocale(localeDE);
registerLocale(localeEN);
registerLocale(localeFR);
registerLocale(localeKO);

const App: React.FC = () => {
  const router = createBrowserRouter(routes);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ReactReduxFirebaseProvider {...reactReduxFirebaseProps}>
          <FeatureController>
            <RoutesProvider>
              <RouterProvider router={router} />
            </RoutesProvider>
          </FeatureController>
        </ReactReduxFirebaseProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
